import request from '@/utils/request'

export function pageCategory(query) {
  return request({
    url: '/biz/giftcard/category/page',
    method: 'get',
    params: query
  })
}

export function saveCategory(data) {
  return request({
    url: '/biz/giftcard/category/save',
    method: 'post',
    data
  })
}

export function deleteCategory(id) {
  return request({
    url: '/biz/giftcard/category/delete',
    method: 'post',
    params: { id }
  })
}

export function listCountry() {
  return request({
    url: '/biz/giftcard/country/list',
    method: 'get'
  })
}

export function pageCountry(query) {
  return request({
    url: '/biz/giftcard/country/page',
    method: 'get',
    params: query
  })
}

export function saveCountry(data) {
  return request({
    url: '/biz/giftcard/country/save',
    method: 'post',
    data
  })
}

export function deleteCountry(id) {
  return request({
    url: '/biz/giftcard/country/delete',
    method: 'post',
    params: { id }
  })
}

export function pageRateTier(query) {
  return request({
    url: '/biz/giftcard/rate-tier/page',
    method: 'get',
    params: query
  })
}

export function getRateTierConfig() {
  return request({
    url: '/biz/giftcard/rate-tier/config/get',
    method: 'get'
  })
}

export function saveRateTierConfig(data) {
  return request({
    url: '/biz/giftcard/rate-tier/config/save',
    method: 'post',
    data
  })
}

export function syncRateTier(data) {
  return request({
    url: '/biz/giftcard/rate-tier/sync',
    method: 'post',
    data
  })
}

export function saveRateTier(data) {
  return request({
    url: '/biz/giftcard/rate-tier/save',
    method: 'post',
    data
  })
}

export function deleteRateTier(id) {
  return request({
    url: '/biz/giftcard/rate-tier/delete',
    method: 'post',
    params: { id }
  })
}
